export const supportedLocales = [
  "cs-cz",
  "da-dk",
  "de-de",
  "el-gr",
  "en-us",
  "es-es",
  "fr-fr",
  "hi-in",
  "id-id",
  "it-it",
  "ko-kr",
  "nl-nl",
  "pl-pl",
  "pt-pt",
  "sv-se",
  "tr-tr",
  "uk-ua",
  "zh-cn"
]

export const localeInfo: { [x: string]: { displayName: string } } = {
  "en-us": {
    displayName: "English"
  },
  "es-es": {
    displayName: "Spanish (Español)"
  },
  "fr-fr": {
    displayName: "French (Français)"
  },
  "zh-cn": {
    displayName: "Chinese (中文)"
  },
  "de-de": {
    displayName: "German (Deutsche)"
  },
  "el-gr": {
    displayName: "Greek (Ελληνικά)"
  },
  "hi-in": {
    displayName: "Hindi (हिन्दी)"
  },
  "id-id": {
    displayName: "Indonesian (Bahasa Indonesia)"
  },
  "pl-pl": {
    displayName: "Polish (Polski)"
  },
  "it-it": {
    displayName: "Italian (Italiano)"
  },
  "ko-kr": {
    displayName: "Korean (한국어)"
  },
  "pt-pt": {
    displayName: "Portuguese (Português)"
  },
  "sv-se": {
    displayName: "Swedish (Svenska)"
  },
  "tr-tr": {
    displayName: "Turkish (Türkçe)"
  },
  "cs-cz": {
    displayName: "Czech (Čeština)"
  },
  "nl-nl": {
    displayName: "Dutch (Nederlands)"
  },
  "da-dk": {
    displayName: "Danish (Dansk)"
  },
  "uk-ua": {
    displayName: "Ukrainian (Українська)"
  }
}

export const landingCountryCodes = ["unitedstates"]

export const phoneNumberPurchaseCountryCodes = ["unitedstates"]

export const supportedCountryCodes = [
  "argentina",
  "australia",
  "austria",
  "belgium",
  "brazil",
  // Conflicts with US
  // "canada",
  "chile",
  "china",
  "colombia",
  "cyprus",
  "czechrepublic",
  "denmark",
  "finland",
  "france",
  "germany",
  "greece",
  "india",
  "indonesia",
  "ireland",
  "italy",
  "korea",
  "lithuania",
  "luxembourg",
  "mexico",
  "netherlands",
  "newzealand",
  "peru",
  "poland",
  "portugal",
  "singapore",
  "southafrica",
  "spain",
  "sweden",
  "switzerland",
  "taiwan",
  "turkey",
  "ukraine",
  "unitedkingdom",
  "unitedstates",
  "venezuela"
]

export const countryCodeInfo: {
  [x: string]: { displayName: any; code: string; default_locale: string; iso: string; displayNameClean: string }
} = {
  argentina: {
    code: "54",
    displayName: "Argentina (+54)",
    displayNameClean: "Argentina",
    default_locale: "es-es",
    iso: "AR"
  },
  australia: {
    code: "61",
    displayName: "Australia (+61)",
    displayNameClean: "Australia",
    default_locale: "en-us",
    iso: "AU"
  },
  austria: {
    code: "43",
    displayName: "Austria (+43)",
    displayNameClean: "Austria",
    default_locale: "de-de",
    iso: "AT"
  },
  belgium: {
    code: "32",
    displayName: "Belgium (+32)",
    displayNameClean: "Belgium",
    default_locale: "fr-fr",
    iso: "BE"
  },
  brazil: {
    code: "55",
    displayName: "Brazil (+55)",
    displayNameClean: "Brazil",
    default_locale: "pt-pt",
    iso: "BR"
  },
  // Conflicts with US
  // canada: {
  //   code: "1",
  //   displayName: "Canada (+1)",
  //   iso: "CA"
  // },
  chile: {
    code: "56",
    displayName: "Chile (+56)",
    displayNameClean: "Chile",
    default_locale: "es-es",
    iso: "CL"
  },
  china: {
    code: "86",
    displayName: "China (+86)",
    displayNameClean: "China",
    default_locale: "zh-cn",
    iso: "CN"
  },
  colombia: {
    code: "57",
    displayName: "Colombia (+57)",
    displayNameClean: "Colombia",
    default_locale: "es-es",
    iso: "CO"
  },
  cyprus: {
    code: "357",
    displayName: "Cyprus (+357)",
    displayNameClean: "Cyprus",
    default_locale: "el-gr",
    iso: "CY"
  },
  czechrepublic: {
    code: "420",
    displayName: "Czech Republic (+420)",
    displayNameClean: "Czech Republic",
    default_locale: "cs-cz",
    iso: "CZ"
  },
  denmark: {
    code: "45",
    displayName: "Denmark (+45)",
    displayNameClean: "Denmark",
    default_locale: "da-dk",
    iso: "DK"
  },
  finland: {
    code: "358",
    displayName: "Finland (+358)",
    displayNameClean: "Finland",
    default_locale: "en-us",
    iso: "FI"
  },
  france: {
    code: "33",
    displayName: "France (+33)",
    displayNameClean: "France",
    default_locale: "fr-fr",
    iso: "FR"
  },
  germany: {
    code: "49",
    displayName: "Germany (+49)",
    displayNameClean: "Germany",
    default_locale: "de-de",
    iso: "DE"
  },
  greece: {
    code: "30",
    displayName: "Greece (+30)",
    displayNameClean: "Greece",
    default_locale: "el-gr",
    iso: "GR"
  },
  india: {
    code: "91",
    displayName: "India (+91)",
    displayNameClean: "India",
    default_locale: "hi-in",
    iso: "IN"
  },
  indonesia: {
    code: "62",
    displayName: "Indonesia (+62)",
    displayNameClean: "Indonesia",
    default_locale: "id-id",
    iso: "ID"
  },
  ireland: {
    code: "353",
    displayName: "Ireland (+353)",
    displayNameClean: "Ireland",
    default_locale: "en-us",
    iso: "IE"
  },
  italy: {
    code: "39",
    displayName: "Italy (+39)",
    displayNameClean: "Italy",
    default_locale: "it-it",
    iso: "IT"
  },
  korea: {
    code: "82",
    displayName: "South Korea (+82)",
    displayNameClean: "South Korea",
    default_locale: "ko-kr",
    iso: "KR"
  },
  lithuania: {
    code: "370",
    displayName: "Lithuania (+370)",
    displayNameClean: "Lithuania",
    default_locale: "en-us",
    iso: "LT"
  },
  luxembourg: {
    code: "352",
    displayName: "Luxembourg (+352)",
    displayNameClean: "Luxembourg",
    default_locale: "fr-fr",
    iso: "LU"
  },
  mexico: {
    code: "52",
    displayName: "Mexico (+52)",
    displayNameClean: "Mexico",
    default_locale: "es-es",
    iso: "MX"
  },
  netherlands: {
    code: "31",
    displayName: "Netherlands (+31)",
    displayNameClean: "Netherlands",
    default_locale: "nl-nl",
    iso: "NL"
  },
  newzealand: {
    code: "64",
    displayName: "New Zealand (+64)",
    displayNameClean: "New Zealand",
    default_locale: "en-us",
    iso: "NZ"
  },
  peru: {
    code: "51",
    displayName: "Peru (+51)",
    displayNameClean: "Peru",
    default_locale: "es-es",
    iso: "PE"
  },
  poland: {
    code: "48",
    displayName: "Poland (+48)",
    displayNameClean: "Poland",
    default_locale: "pl-pl",
    iso: "PL"
  },
  portugal: {
    code: "351",
    displayName: "Portugal (+351)",
    displayNameClean: "Portugal",
    default_locale: "pt-pt",
    iso: "PT"
  },
  singapore: {
    code: "65",
    displayName: "Singapore (+65)",
    displayNameClean: "Singapore",
    default_locale: "en-us",
    iso: "SG"
  },
  southafrica: {
    code: "27",
    displayName: "South Africa (+27)",
    displayNameClean: "South Africa",
    default_locale: "en-us",
    iso: "ZA"
  },
  spain: {
    code: "34",
    displayName: "Spain (+34)",
    displayNameClean: "Spain",
    default_locale: "es-es",
    iso: "ES"
  },
  sweden: {
    code: "46",
    displayName: "Sweden (+46)",
    displayNameClean: "Sweden",
    default_locale: "sv-se",
    iso: "SE"
  },
  switzerland: {
    code: "41",
    displayName: "Switzerland (+41)",
    displayNameClean: "Switzerland",
    default_locale: "de-de",
    iso: "CH"
  },
  taiwan: {
    code: "886",
    displayName: "Taiwan (+886)",
    displayNameClean: "Taiwan",
    default_locale: "zh-cn",
    iso: "TW"
  },
  turkey: {
    code: "90",
    displayName: "Turkey (+90)",
    displayNameClean: "Turkey",
    default_locale: "tr-tr",
    iso: "TR"
  },
  ukraine: {
    code: "380",
    displayName: "Ukraine (+380)",
    displayNameClean: "Ukraine",
    default_locale: "uk-ua",
    iso: "UA"
  },
  unitedkingdom: {
    code: "44",
    displayName: "United Kingdom (+44)",
    displayNameClean: "United Kingdom",
    default_locale: "en-us",
    iso: "GB"
  },
  unitedstates: {
    code: "1",
    displayName: "United States & Canada (+1)",
    displayNameClean: "United States",
    default_locale: "en-us",
    iso: "US"
  },
  venezuela: {
    code: "58",
    displayName: "Venezuela (+58)",
    displayNameClean: "Venezuela",
    default_locale: "es-es",
    iso: "VE"
  }
}

export const allCodes = supportedCountryCodes.map((code) => countryCodeInfo[code].code)

export const US_STATES: string[] = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming"
]

export const TIMEZONES = [
  "Africa/Abidjan",
  "Africa/Accra",
  "Africa/Addis_Ababa",
  "Africa/Algiers",
  "Africa/Asmara",
  "Africa/Bamako",
  "Africa/Bangui",
  "Africa/Banjul",
  "Africa/Bissau",
  "Africa/Blantyre",
  "Africa/Brazzaville",
  "Africa/Bujumbura",
  "Africa/Cairo",
  "Africa/Casablanca",
  "Africa/Ceuta",
  "Africa/Conakry",
  "Africa/Dakar",
  "Africa/Dar_es_Salaam",
  "Africa/Djibouti",
  "Africa/Douala",
  "Africa/El_Aaiun",
  "Africa/Freetown",
  "Africa/Gaborone",
  "Africa/Harare",
  "Africa/Johannesburg",
  "Africa/Juba",
  "Africa/Kampala",
  "Africa/Khartoum",
  "Africa/Kigali",
  "Africa/Kinshasa",
  "Africa/Lagos",
  "Africa/Libreville",
  "Africa/Lome",
  "Africa/Luanda",
  "Africa/Lubumbashi",
  "Africa/Lusaka",
  "Africa/Malabo",
  "Africa/Maputo",
  "Africa/Maseru",
  "Africa/Mbabane",
  "Africa/Mogadishu",
  "Africa/Monrovia",
  "Africa/Nairobi",
  "Africa/Ndjamena",
  "Africa/Niamey",
  "Africa/Nouakchott",
  "Africa/Ouagadougou",
  "Africa/Porto-Novo",
  "Africa/Sao_Tome",
  "Africa/Tripoli",
  "Africa/Tunis",
  "Africa/Windhoek",
  "America/Adak",
  "America/Anchorage",
  "America/Anguilla",
  "America/Antigua",
  "America/Araguaina",
  "America/Argentina/Buenos_Aires",
  "America/Argentina/Catamarca",
  "America/Argentina/Cordoba",
  "America/Argentina/Jujuy",
  "America/Argentina/La_Rioja",
  "America/Argentina/Mendoza",
  "America/Argentina/Rio_Gallegos",
  "America/Argentina/Salta",
  "America/Argentina/San_Juan",
  "America/Argentina/San_Luis",
  "America/Argentina/Tucuman",
  "America/Argentina/Ushuaia",
  "America/Aruba",
  "America/Asuncion",
  "America/Atikokan",
  "America/Bahia",
  "America/Bahia_Banderas",
  "America/Barbados",
  "America/Belem",
  "America/Belize",
  "America/Blanc-Sablon",
  "America/Boa_Vista",
  "America/Bogota",
  "America/Boise",
  "America/Cambridge_Bay",
  "America/Campo_Grande",
  "America/Cancun",
  "America/Caracas",
  "America/Cayenne",
  "America/Cayman",
  "America/Chicago",
  "America/Chihuahua",
  "America/Ciudad_Juarez",
  "America/Costa_Rica",
  "America/Creston",
  "America/Cuiaba",
  "America/Curacao",
  "America/Danmarkshavn",
  "America/Dawson",
  "America/Dawson_Creek",
  "America/Denver",
  "America/Detroit",
  "America/Dominica",
  "America/Edmonton",
  "America/Eirunepe",
  "America/El_Salvador",
  "America/Fort_Nelson",
  "America/Fortaleza",
  "America/Glace_Bay",
  "America/Goose_Bay",
  "America/Grand_Turk",
  "America/Grenada",
  "America/Guadeloupe",
  "America/Guatemala",
  "America/Guayaquil",
  "America/Guyana",
  "America/Halifax",
  "America/Havana",
  "America/Hermosillo",
  "America/Indiana/Indianapolis",
  "America/Indiana/Knox",
  "America/Indiana/Marengo",
  "America/Indiana/Petersburg",
  "America/Indiana/Tell_City",
  "America/Indiana/Vevay",
  "America/Indiana/Vincennes",
  "America/Indiana/Winamac",
  "America/Inuvik",
  "America/Iqaluit",
  "America/Jamaica",
  "America/Juneau",
  "America/Kentucky/Louisville",
  "America/Kentucky/Monticello",
  "America/Kralendijk",
  "America/La_Paz",
  "America/Lima",
  "America/Los_Angeles",
  "America/Lower_Princes",
  "America/Maceio",
  "America/Managua",
  "America/Manaus",
  "America/Marigot",
  "America/Martinique",
  "America/Matamoros",
  "America/Mazatlan",
  "America/Menominee",
  "America/Merida",
  "America/Metlakatla",
  "America/Mexico_City",
  "America/Miquelon",
  "America/Moncton",
  "America/Monterrey",
  "America/Montevideo",
  "America/Montserrat",
  "America/Nassau",
  "America/New_York",
  "America/Nome",
  "America/Noronha",
  "America/North_Dakota/Beulah",
  "America/North_Dakota/Center",
  "America/North_Dakota/New_Salem",
  "America/Nuuk",
  "America/Ojinaga",
  "America/Panama",
  "America/Paramaribo",
  "America/Phoenix",
  "America/Port-au-Prince",
  "America/Port_of_Spain",
  "America/Porto_Velho",
  "America/Puerto_Rico",
  "America/Punta_Arenas",
  "America/Rankin_Inlet",
  "America/Recife",
  "America/Regina",
  "America/Resolute",
  "America/Rio_Branco",
  "America/Santarem",
  "America/Santiago",
  "America/Santo_Domingo",
  "America/Sao_Paulo",
  "America/Scoresbysund",
  "America/Sitka",
  "America/St_Barthelemy",
  "America/St_Johns",
  "America/St_Kitts",
  "America/St_Lucia",
  "America/St_Thomas",
  "America/St_Vincent",
  "America/Swift_Current",
  "America/Tegucigalpa",
  "America/Thule",
  "America/Tijuana",
  "America/Toronto",
  "America/Tortola",
  "America/Vancouver",
  "America/Whitehorse",
  "America/Winnipeg",
  "America/Yakutat",
  "Antarctica/Casey",
  "Antarctica/Davis",
  "Antarctica/DumontDUrville",
  "Antarctica/Macquarie",
  "Antarctica/Mawson",
  "Antarctica/McMurdo",
  "Antarctica/Palmer",
  "Antarctica/Rothera",
  "Antarctica/Syowa",
  "Antarctica/Troll",
  "Antarctica/Vostok",
  "Arctic/Longyearbyen",
  "Asia/Aden",
  "Asia/Almaty",
  "Asia/Amman",
  "Asia/Anadyr",
  "Asia/Aqtau",
  "Asia/Aqtobe",
  "Asia/Ashgabat",
  "Asia/Atyrau",
  "Asia/Baghdad",
  "Asia/Bahrain",
  "Asia/Baku",
  "Asia/Bangkok",
  "Asia/Barnaul",
  "Asia/Beirut",
  "Asia/Bishkek",
  "Asia/Brunei",
  "Asia/Chita",
  "Asia/Choibalsan",
  "Asia/Colombo",
  "Asia/Damascus",
  "Asia/Dhaka",
  "Asia/Dili",
  "Asia/Dubai",
  "Asia/Dushanbe",
  "Asia/Famagusta",
  "Asia/Gaza",
  "Asia/Hebron",
  "Asia/Ho_Chi_Minh",
  "Asia/Hong_Kong",
  "Asia/Hovd",
  "Asia/Irkutsk",
  "Asia/Jakarta",
  "Asia/Jayapura",
  "Asia/Jerusalem",
  "Asia/Kabul",
  "Asia/Kamchatka",
  "Asia/Karachi",
  "Asia/Kathmandu",
  "Asia/Khandyga",
  "Asia/Kolkata",
  "Asia/Krasnoyarsk",
  "Asia/Kuala_Lumpur",
  "Asia/Kuching",
  "Asia/Kuwait",
  "Asia/Macau",
  "Asia/Magadan",
  "Asia/Makassar",
  "Asia/Manila",
  "Asia/Muscat",
  "Asia/Nicosia",
  "Asia/Novokuznetsk",
  "Asia/Novosibirsk",
  "Asia/Omsk",
  "Asia/Oral",
  "Asia/Phnom_Penh",
  "Asia/Pontianak",
  "Asia/Pyongyang",
  "Asia/Qatar",
  "Asia/Qostanay",
  "Asia/Qyzylorda",
  "Asia/Riyadh",
  "Asia/Sakhalin",
  "Asia/Samarkand",
  "Asia/Seoul",
  "Asia/Shanghai",
  "Asia/Singapore",
  "Asia/Srednekolymsk",
  "Asia/Taipei",
  "Asia/Tashkent",
  "Asia/Tbilisi",
  "Asia/Tehran",
  "Asia/Thimphu",
  "Asia/Tokyo",
  "Asia/Tomsk",
  "Asia/Ulaanbaatar",
  "Asia/Urumqi",
  "Asia/Ust-Nera",
  "Asia/Vientiane",
  "Asia/Vladivostok",
  "Asia/Yakutsk",
  "Asia/Yangon",
  "Asia/Yekaterinburg",
  "Asia/Yerevan",
  "Atlantic/Azores",
  "Atlantic/Bermuda",
  "Atlantic/Canary",
  "Atlantic/Cape_Verde",
  "Atlantic/Faroe",
  "Atlantic/Madeira",
  "Atlantic/Reykjavik",
  "Atlantic/South_Georgia",
  "Atlantic/St_Helena",
  "Atlantic/Stanley",
  "Australia/Adelaide",
  "Australia/Brisbane",
  "Australia/Broken_Hill",
  "Australia/Darwin",
  "Australia/Eucla",
  "Australia/Hobart",
  "Australia/Lindeman",
  "Australia/Lord_Howe",
  "Australia/Melbourne",
  "Australia/Perth",
  "Australia/Sydney",
  "Canada/Atlantic",
  "Canada/Central",
  "Canada/Eastern",
  "Canada/Mountain",
  "Canada/Newfoundland",
  "Canada/Pacific",
  "Europe/Amsterdam",
  "Europe/Andorra",
  "Europe/Astrakhan",
  "Europe/Athens",
  "Europe/Belgrade",
  "Europe/Berlin",
  "Europe/Bratislava",
  "Europe/Brussels",
  "Europe/Bucharest",
  "Europe/Budapest",
  "Europe/Busingen",
  "Europe/Chisinau",
  "Europe/Copenhagen",
  "Europe/Dublin",
  "Europe/Gibraltar",
  "Europe/Guernsey",
  "Europe/Helsinki",
  "Europe/Isle_of_Man",
  "Europe/Istanbul",
  "Europe/Jersey",
  "Europe/Kaliningrad",
  "Europe/Kirov",
  "Europe/Kyiv",
  "Europe/Lisbon",
  "Europe/Ljubljana",
  "Europe/London",
  "Europe/Luxembourg",
  "Europe/Madrid",
  "Europe/Malta",
  "Europe/Mariehamn",
  "Europe/Minsk",
  "Europe/Monaco",
  "Europe/Moscow",
  "Europe/Oslo",
  "Europe/Paris",
  "Europe/Podgorica",
  "Europe/Prague",
  "Europe/Riga",
  "Europe/Rome",
  "Europe/Samara",
  "Europe/San_Marino",
  "Europe/Sarajevo",
  "Europe/Saratov",
  "Europe/Simferopol",
  "Europe/Skopje",
  "Europe/Sofia",
  "Europe/Stockholm",
  "Europe/Tallinn",
  "Europe/Tirane",
  "Europe/Ulyanovsk",
  "Europe/Vaduz",
  "Europe/Vatican",
  "Europe/Vienna",
  "Europe/Vilnius",
  "Europe/Volgograd",
  "Europe/Warsaw",
  "Europe/Zagreb",
  "Europe/Zurich",
  "GMT",
  "Indian/Antananarivo",
  "Indian/Chagos",
  "Indian/Christmas",
  "Indian/Cocos",
  "Indian/Comoro",
  "Indian/Kerguelen",
  "Indian/Mahe",
  "Indian/Maldives",
  "Indian/Mauritius",
  "Indian/Mayotte",
  "Indian/Reunion",
  "Pacific/Apia",
  "Pacific/Auckland",
  "Pacific/Bougainville",
  "Pacific/Chatham",
  "Pacific/Chuuk",
  "Pacific/Easter",
  "Pacific/Efate",
  "Pacific/Fakaofo",
  "Pacific/Fiji",
  "Pacific/Funafuti",
  "Pacific/Galapagos",
  "Pacific/Gambier",
  "Pacific/Guadalcanal",
  "Pacific/Guam",
  "Pacific/Honolulu",
  "Pacific/Kanton",
  "Pacific/Kiritimati",
  "Pacific/Kosrae",
  "Pacific/Kwajalein",
  "Pacific/Majuro",
  "Pacific/Marquesas",
  "Pacific/Midway",
  "Pacific/Nauru",
  "Pacific/Niue",
  "Pacific/Norfolk",
  "Pacific/Noumea",
  "Pacific/Pago_Pago",
  "Pacific/Palau",
  "Pacific/Pitcairn",
  "Pacific/Pohnpei",
  "Pacific/Port_Moresby",
  "Pacific/Rarotonga",
  "Pacific/Saipan",
  "Pacific/Tahiti",
  "Pacific/Tarawa",
  "Pacific/Tongatapu",
  "Pacific/Wake",
  "Pacific/Wallis",
  "US/Alaska",
  "US/Arizona",
  "US/Central",
  "US/Eastern",
  "US/Hawaii",
  "US/Mountain",
  "US/Pacific",
  "UTC"
]
